import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-hidden"
}
const _hoisted_2 = ["src"]

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import {
  PropType,
  onMounted,
  onUnmounted,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNotification',
  props: {
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String as PropType<'success' | 'error' | 'warning'>,
    required: true,
  },
  permanent: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

let notificationTimeout: ReturnType<typeof setTimeout> | undefined;

function _clearTimeout(): void {
  if (!notificationTimeout) {
    return;
  }

  clearTimeout(notificationTimeout);
  notificationTimeout = undefined;
}

function _addTimeout(): void {
  if (props.permanent) {
    return;
  }

  notificationTimeout = setTimeout(() => {
    emits('close');
  }, 5000);
}

onMounted(() => {
  _clearTimeout();
  _addTimeout();
});

onUnmounted(() => {
  _clearTimeout();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center justify-between rounded-lg px-4 py-2 shadow-lg", {
        'bg-[#FFF9EB] text-[#A6813D]': __props.type === 'warning',
        'bg-[#EEFBF2] text-[#458563]': __props.type === 'success',
        'bg-[#FDF1F5] text-[#E13452]': __props.type === 'error',
      }])
    }, [
      _createElementVNode("p", null, _toDisplayString(__props.message), 1),
      (!__props.permanent)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "rounded-full p-1 hover:bg-red-300",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "size-6" })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.permanent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: require('@/assets/unauthorized.png'),
            alt: "unauthorized access",
            class: "mx-auto mt-2 h-100"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})